
<template>

	<b-overlay :show="long_operation">
	<div class="natural-900" style="overflow-x: hidden;background-color: var(--bft-blue-50);">

	<div v-if="is_logged_in">

		<b-navbar style="padding-left: 2rem;background-color: transparent !important;">
			<b-navbar-brand style="font-size: .75rem;" class="py-0 natural-400">
				Процедура ГКО • Определение кадастровой стоимости
			</b-navbar-brand>
		</b-navbar>

		<my_window v-if="roles_loaded && procedure_loaded" :sidebar_visible="main_menu_visible">

			<template v-slot:resizable>

				<sidebar class="sidebar_groups">

					<v-select v-if="procedures.length > 1" :clearable="false" v-model="current_procedure_id" :reduce="obj => obj.procedure_id" :options="procedures" v-on:input="set_current_procedure" required/>

					<tree ref="main_tree_groups" class="tree main_tree" :data="main_tree.main_tree_groups" :options="main_tree_options" v-on:node:clicked="select" v-on:tree:mounted="update" v-on:node:expanded="save_expanded_node_names" v-on:node:collapsed="save_expanded_node_names" style="width: 100%; overflow-x: hidden !important">

						<div slot-scope="{ node }" class="d-flex w-100 justify-content-between">

							<div :id="node.data.group_id">{{ get_group_name(node) }}</div>
							
							<b-dropdown v-if="node.states.selected && ! node.data.has_cost_evaluation && !node.data.not_editable && ((check_roles([ 'group_tree' ]) && node.data.parent_id)
							|| (node.children.length && check_roles([ 'grouping' ])))" boundary="window" :popper-opts="{ positionFixed: true }" class="transparent without-after">
								<template #button-content>
									<base-icon name="more_vert" />
								</template>
								
								<b-dropdown-item v-if="! node.data.is_fixed && check_roles([ 'group_tree' ])" v-on:click="rename_group">Переименовать оценочную подгруппу</b-dropdown-item>
								<b-dropdown-item v-if="node.data.parent_id && check_roles([ 'group_tree' ])" v-on:click="add_child_group">Создать оценочную подгруппу</b-dropdown-item>
								<b-dropdown-item v-if="node.children.length && check_roles([ 'grouping' ])" v-on:click="get_set_group_auto_many_params">Разгруппировать объекты оценки/объекты-аналоги</b-dropdown-item>
								<b-dropdown-item v-if="node.data.parent_id && ! node.data.is_fixed && ! node.children.length && check_roles([ 'group_tree' ])" v-on:click="delete_group">Удалить оценочную подгруппу</b-dropdown-item>
							</b-dropdown>

							<b-tooltip v-if="node.data.tooltip" noninteractive custom-class="main_tree_groups_tooltip"
								:target="node.data.group_id"
								triggers="hover" placement="rightbottom" boundary="window">
								{{ node.data.tooltip }}
							</b-tooltip>

						</div>

					</tree>

				</sidebar>
				<sidebar  class="sidebar_without_groups">

					<tree ref="main_tree" class="tree main_tree" :data="main_tree.main_tree" :options="main_tree_options" v-on:node:clicked="select" v-on:tree:mounted="update" v-on:node:expanded="save_expanded_node_names" v-on:node:collapsed="save_expanded_node_names" style="width: 100%; overflow-x: hidden !important">

						<div slot-scope="{ node }">

							<div v-if="node.data.url"><router-link :to="node.data.url">{{ node.text }}</router-link></div>
							<div v-else-if="node.text">{{ node.text }}</div>

						</div>

					</tree>

				</sidebar>

			</template>

			<template v-slot>

				<my_content style="width: 100%;">

					<fullscreen id="fullscreen" v-model="fullscreen" style="background-color: white;width: 100%;height: 100%;" :teleport="false">						

						<add v-if="group_node" ref="add_child_group" :parent_id="group_node.data.group_id" v-on:need_refresh="() => add_group()"/>
						<rename v-if="group_node" ref="rename" :id="group_node.data.group_id" v-on:need_refresh="() => update()"/>
						<setGroupAutoMany v-if="group_node" ref="set_group_auto_many" v-on:group="set_group_auto_many"/>

					<b-container class="d-flex py-3" style="height: 100%;flex-direction: column;" fluid>

						<my_header v-if="group_node" ref="header"
							:group_node="group_node"
							:fullscreen="fullscreen" @toggle_fullscreen="set_fullscreen"
						/>

						<div class="my_content">

							<router-view :key="$route.fullPath" ref="content"/>

						</div>

					</b-container>

						<b-toaster name="fs-ntf"></b-toaster>
					</fullscreen>

				</my_content>

			</template>

		</my_window>

	</div>

	<div v-else>

		<b-container fluid><router-view/></b-container>

	</div>

	</div>
	</b-overlay>

</template>

<script>

import api from "./api"
import attrs from "./api/attrs"
import main_tree from "./api/main_tree"
import my_window from "./third_party/main_window/window"
import sidebar from "./third_party/main_window/sidebar"
import my_content from "./third_party/main_window/content"

import my_header from "./components/header"

import add from "./components/cadastral/groups/add"
import rename from "./components/cadastral/groups/rename"
import setGroupAutoMany from "./components/widgets/set_group_auto_many.vue"
import { bus } from "./api/bus"
import variables from "./api/variables"

export default
{
	data()
	{
		return {

			roles_loaded : false,
			procedure_loaded : false,
			main_menu_visible : true,
			main_tree : { main_tree_groups : [], main_tree : [], },
			roles : [],

			main_tree_options : {
				parentSelect: true
			},
			bottom_tree_options : {},

			group_paths : [
				'groups',
				'encoding_rules',
				'objects',
				'analogues',
				'analoguesprofitable',
				'expensives',
				'cost_evaluations',
				'group_statistic'
			],

			fullscreen: false,
			long_operation : false,

			group_node : null,

			procedures : [],
			current_procedure_id : null,

		}
	},

	components :
	{
		my_window,
		sidebar,
		my_content,

		my_header,

		add,
		rename,
		setGroupAutoMany,
	},

	computed :
	{
		is_logged_in()
		{
			return api.get_session(this) != null
		},
	},

	watch :
	{
		$route(to)
		{
			if(to && to.name)
			{
				if(this.$route.meta)
					document.title = to.meta.title || "МОКС"

				var full_path = to.fullPath				
				full_path = full_path.substring(0, full_path.indexOf("storage_prefix") - 1)

				var nodes = []

				if(this.$refs.main_tree)
				{
					if(to.query.key != null)
						nodes = this.$refs.main_tree.find({ data : { key : to.query.key }})

					if(nodes.length == 0)
						nodes = this.$refs.main_tree.find({ data : { url : full_path }})

					if(nodes.length)// && ( to.params == null || ! to.params.disable_updating_main_tree ))
					{
						api.expand_node_in_tree(this.$refs.main_tree, null, false, true, nodes)
						nodes[0].select()
					}
					else
						this.$refs.main_tree.selected().forEach(node => node.unselect())

					var groups_nodes = []
					var key = to.query.key

					if(key == null && to.params)
						key = to.params.key

					if(key != null && this.main_tree)
					{
						groups_nodes = this.$refs.main_tree_groups.find({ data : { objects_key : key } })

						if(groups_nodes.length == 0)
						{
							groups_nodes = this.$refs.main_tree_groups.find({ data : { analogues_key : key } })
						}
					}

					if(groups_nodes.length == 0)
					{
						var [ , path, id ] = to.path.split('/')

						if (this.group_paths.includes(path) && id)
						{
							groups_nodes = this.$refs.main_tree_groups.find({ data : { group_id : id } })
						}
					}
					
					if(groups_nodes.length)// && ( to.params == null || ! to.params.disable_updating_main_tree ))
					{
						api.expand_node_in_tree(this.$refs.main_tree_groups, null, false, true, groups_nodes)
						this.select_group(groups_nodes[0])
					}
					else if (!(to.name == 'analogues' || to.name == 'analoguesprofitable' || to.name == 'expensives' || to.name == 'objects'))
					{
						this.unselect_group()
					}
					else
					{
						this.select_group(this.$refs.main_tree_groups.find({ data : { group_id : this.$root.current_group.group_id } })[0])
					}
				}
			}
		},
	},

	beforeMount()
	{
		this.$root.$on("start_long_operation", () => { this.long_operation = true })
		this.$root.$on("stop_long_operation", () => { this.long_operation = false })
	},

	mounted()
	{
		if(this.$route.meta)
			document.title = this.$route.meta.title || "МОКС"

		bus.$on("update_main_tree", () => main_tree.create(this).then(() => { this.update() }))

		return api.load_roles(this).then(
			() =>
			{
				this.roles_loaded = true
				var func =
					first =>
					{
						api.call(this, "system", "procedure", {},
							response =>
							{
								this.$root.readonly = window.localStorage.getItem("readonly") === "true"

								this.$root.not_editable = response.data.article != "14"
								this.procedure_loaded = true

								var name, connected_name

								if(response.data.procedure_id.includes("parcel"))
								{
									name = "Земельные участки"
									connected_name = "Объекты недвижимости, за исключением земельных участков"
								}
								else
								{
									connected_name = "Земельные участки"
									name = "Объекты недвижимости, за исключением земельных участков"
								}

								this.procedures = [ { label : name, procedure_id : response.data.procedure_id } ]
								this.current_procedure_id = response.data.procedure_id

								if(response.data.connected_procedure_id != null)
									this.procedures.push({ label : connected_name, procedure_id : response.data.connected_procedure_id })
						
								main_tree.create(this).then(() => {this.main_tree = main_tree.get(this)})
								attrs.load(this)

								this.$bvToast.hide()
							},
							( self, response ) =>
							{
								if(first)
									api.show_error_box(this, response, null)

								var elem = document.querySelector(".ntf_msg")

								if(elem)
									elem.innerHTML = response.description

								setTimeout(() => func(false), 3000)
							})
					}

				func(true, 0)
			})
	},

	updated()
	{
		this.update()
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		update()
		{
			if(this.$refs.main_tree != null && this.$refs.main_tree.model.length == 0
			|| this.$refs.main_tree_groups != null && this.$refs.main_tree_groups.model.length == 0)
			{
				this.main_tree = main_tree.get(this)
				this.$refs.main_tree.setModel(this.main_tree.main_tree)
				this.$refs.main_tree_groups.setModel(this.main_tree.main_tree_groups)
			}
		},

		select(node)
		{
			// if(node.data.objects.clean_cadastral_local_filter)
			/* 3904
			if(this.$refs.header && this.$refs.header.main_tree_groups_type == this.$refs.header.tabs.objects)
			{
				const self = { service : "cadastral_objects", single_element_url : "objects" }


				api.storage.set(this, storage_name, "{}")
			}

			// if(node.data.analogues.clean_analogues_local_filter)
			if(this.$refs.header && this.$refs.header.main_tree_groups_type == this.$refs.header.tabs.analogues)
			{
				const self = { service : "cadastral_analogues", single_element_url : "analogues" }
				const storage_name = api.storage.name(self, "filters")

				api.storage.set(this, storage_name, "{}")
			}
				*/

			// if (!Object.keys(node.data).includes("group_id"))
			// {
			// 	this.unselect_group()
			// }
			let path
			
			if(node.data.callback != null)
			{
				node.data.callback(this)
			}
			else if(node.data.router_name != null)
			{
				path =
				{
					name : node.data.router_name,
					params : { query : node.data.query, disable_updating_main_tree : true },
					query : { t : new Date().getTime() }, // Костыль для ошибки с переходом на тот же path
				}
			}
			else if (node.data.url)
			{
				path = node.data.url
			}
			else if (node.data.group_id)
			{
				path = this.get_new_path(node, this.$route.path.split("/")[1], true)
			}

			if (path)
			{
				this.$router.push(path)
					.catch((e) => {if (e.type != 2) console.error(e)})
			}
		},

		set_main_tree(main_tree, set_model)
		{
			this.main_tree = main_tree
			
			var promise_groups = set_model ? this.$refs.main_tree_groups.setModel(main_tree.main_tree_groups) : new Promise(resolve => resolve())

			promise_groups.then(
				() =>
				{
					const expanded_node_names = api.storage.get(this, "expanded_groups_node_names", [], Array)
					var node

					if(this.$route.query && this.$route.query.key)
					{
						node = api.expand_node_in_tree(this.$refs.main_tree_groups, { data : { objects_key : this.$route.query.key } })
						
						if(!node)
						{
							node = api.expand_node_in_tree(this.$refs.main_tree_groups, { data : { analogues_key : this.$route.query.key } })
						}
					}
					else
					{
						var [ , path, id ] = this.$route.path.split('/')

						if (this.group_paths.includes(path) && id)
						{
							node = api.expand_node_in_tree(this.$refs.main_tree_groups, { data : { group_id : id } })
						}
					}

					if(node)
					{
						this.select_group(node)
					}

					expanded_node_names.forEach(
						name => api.expand_node_in_tree(this.$refs.main_tree_groups, { data : { group_id : name } }, true, false)
					)
				})
			
			var promise = set_model ? this.$refs.main_tree.setModel(main_tree.main_tree) : new Promise(resolve => resolve())

			const expanded_node_names = api.storage.get(this, "expanded_node_names", [], Array)

			promise.then(
				() =>
				{
					// const expanded_node_names = api.storage.get(this, "expanded_node_names", [], Array)
					var node

					if(this.$route.query && this.$route.query.key)
						node = api.expand_node_in_tree(this.$refs.main_tree, { data : { key : this.$route.query.key } })
					else
					{
						var full_path = this.$route.fullPath

						full_path = full_path.substring(0, full_path.indexOf("storage_prefix") - 1)

						node = api.expand_node_in_tree(this.$refs.main_tree, { data : { url : full_path } })
					}

					if(node)
						node.select()

					expanded_node_names.forEach(
						name =>
						{
							var res = api.expand_node_in_tree(this.$refs.main_tree, { data : { key : name } }, true, false)

							if(res == null)
								res = api.expand_node_in_tree(this.$refs.main_tree, { data : { url : name } }, true, false)

							if(res == null)
								res = api.expand_node_in_tree(this.$refs.main_tree, { text : name }, true, false)
						})
				})
			
		},

		save_expanded_node_names()
		{
			var is_expanded =
			node =>
				{
					if(! node.states.expanded)
						return false

					if(node.parent == null)
						return true

					return is_expanded(node.parent)
				}
				
			var expanded_groups_node_names = []

			this.$refs.main_tree_groups.findAll({ state : { expanded : true } }).forEach(
				node =>
				{
					var key = node.data.group_id

					// if(key == "#")
					// 	key = node.data.key

					// if(key == null)
					// 	key = node.text

					if(is_expanded(node))
						expanded_groups_node_names.push(key)
				})

			api.storage.set(this, "expanded_groups_node_names", JSON.stringify(expanded_groups_node_names))

			var expanded_node_names = []

			this.$refs.main_tree.findAll({ state : { expanded : true } }).forEach(
				node =>
				{
					var key = node.data.url

					if(key == "#")
						key = node.data.key

					if(key == null)
						key = node.text

					if(is_expanded(node))
						expanded_node_names.push(key)
				})

			api.storage.set(this, "expanded_node_names", JSON.stringify(expanded_node_names))
		},

		set_fullscreen() 
		{
			this.fullscreen = !this.fullscreen
		},

		// #############################################################################

		get_new_path(node, name, force_not_bad = false, additional_query = null)
		{
			const paths = ['groups', 'objects', 'group_statistic']
			const analogues_paths = ['analogues', 'analoguesprofitable', 'expensives']

			if (!node.children.length)
			{
				paths.push('encoding_rules')

				if (node.data.has_cost_evaluation)
				{
					paths.push('cost_evaluations')
				}
			}

			if (!node.data.not_editable)
			{
				paths.push(...analogues_paths)
			}
			
			if (!paths.includes(name)) { name = 'groups' }

			if(name == 'objects' || analogues_paths.includes(name))
			{
				const key = name == 'objects' ? node.data.objects_key : node.data.analogues_key
				const is_bad = ! force_not_bad && this.$route.params && ( ( this.$route.params.query && this.$route.params.query.indexOf("cadastral_group_bad") >= 0 ) || ( this.$route.query && this.$route.query.query && this.$route.query.query.indexOf("cadastral_group_bad") >= 0 ) )
				const query_key = is_bad ? "cadastral_group_bad" : "cadastral_group"
			
				var query = { "and" : [ { keys : [ query_key ], operation : query_key, args : [ node.data.group_id, node.data.full_name ] } ]}
				var full_query = api.deep_clone(query)

				if(additional_query != null)
					full_query.and.push(additional_query)

				const route_data = this.$router.resolve(
					{
						name : name,
						query :
						{
							query : JSON.stringify(query),
							full_query : JSON.stringify(full_query),
							key : key,
							force : true,
						},
					})

				return route_data.href
			}
			else if (name == 'cost_evaluations')
			{
				const active_step_from_storage = api.storage.get(this, `cost_evaluation_${node.data.group_id}`, null, Object)

				if (active_step_from_storage && active_step_from_storage.active_step)
				{
					const path = active_step_from_storage.active_step.split("_")[0]

					if (path == 'results' || node.data['has_cost_evaluation_' + path])
					{
						return '/' + name + '/' + node.data.group_id + '/' + path
					}
				}

				if (this.$route.params.type
					&& Object.values(variables.CE_approaches.types).includes(this.$route.params.type)
					&& (
						["comparative", "expensive", "profitable"].includes(this.$route.params.type)
						|| this.$route.params.id === node.data.group_id
						|| node.data.has_cost_evaluation_individual && this.$route.params.type === "individual"
					)
				)
				{
					return '/' + name + '/' + node.data.group_id + '/' + this.$route.params.type
				}

				if (node.data.has_cost_evaluation_comparative)
				{
					return '/' + name + '/' + node.data.group_id + '/comparative'
				} else if (node.data.has_cost_evaluation_expensive)
				{
					return '/' + name + '/' + node.data.group_id + '/expensive'
				} else if (node.data.has_cost_evaluation_profitable)
				{
					return '/' + name + '/' + node.data.group_id + '/profitable'
				} else if (node.data.has_cost_evaluation_individual)
				{
					return '/' + name + '/' + node.data.group_id + '/individual'
				}
			}
			else if (name == 'groups')
			{
				if (!(this.$route.params.type == "filters" || this.$route.params.type == "structure"))
				{
					return '/' + name + '/' + node.data.group_id + '/filters'
				}
				else
				{
					return '/' + name + '/' + node.data.group_id + '/' + this.$route.params.type
				}
			}


			return '/' + name + '/' + node.data.group_id
		},

		select_group(node)
		{
            node.select()
			this.group_node = node
			this.$root.current_group = node.data
		},

		unselect_group()
		{
			this.$refs.main_tree_groups.selected().forEach(node => node.unselect())
			this.group_node = null
		},

		get_group_name(node)
		{
			const current_path = this.$route.path.split("/")[1]
			return current_path == 'objects'
					? node.data.objects_text :
					current_path == 'analogues' || current_path == 'analoguesprofitable' || current_path == 'expensives'
						? node.data.analogues_text
						: node.text
		},

		// #############################################################################
		// modals

		add_child_group()
		{
			this.$refs.add_child_group.execute()
		},

		rename_group()
		{
			this.$refs.rename.execute(this.group_node.text)
		},

		delete_group()
		{
			this.$bvModal.msgBoxConfirm(
				"Вы действительно хотите удалить оценочную подгруппу?",
				{
					title : "Подтверждение удаления",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
						{
							this.wait = true

							api.call(this, "cadastral_groups", "delete", { id : this.group_node.data.group_id },
								() =>
									{
										api.show_notification(this, "Оценочная подгруппа удалена")
										main_tree.create(this).then(() => this.$router.push("/groups/" + this.group_node.data.parent_id + "/filters"))
									}
							)
							.then(() => { this.wait = false })
						}
					})
		},

		// #############################################################################

		add_group()
		{
			this.update()
			api.show_notification(this, "Оценочная подгруппа создана")
		},

		get_set_group_auto_many_params()
		{
			this.$refs.set_group_auto_many.execute()
		},

		set_group_auto_many(params)
		{
			api.call_long_operation(this, `Группировка в группе ${this.group_node.data.full_name}`,
				"cadastral_groups",
				"set_group_auto_many_both_cadastral_object_and_analogue",
				{ id : this.group_node.data.group_id, all : params.all },
				response =>
					{
						main_tree.create(this)

						api.open_response_url(response)
					},
				{ success_msg : "Группировка на основании фильтров завершена" }
			)
		},

		// #############################################################################

		set_current_procedure(new_current_procedure_id)
		{
			window.sessionStorage.setItem("procedure", new_current_procedure_id)
			main_tree.create(this)
			this.$router.replace({ path : "/", query : { "procedure" : new_current_procedure_id } })
		},
	},
}

</script>

<style>
@font-face {
  font-family: "Inter";
  src: url('~@/assets/fonts/Inter-VariableFont_slnt,wght.ttf');
}

*
{
	font-family: "Inter";
	hyphens: auto;
	word-break: auto-phrase; /*break-word; 4085*/
}

*:focus-visible
{
	outline: .125rem solid var(--bft-neutral-500);
	border-radius: .25rem;
	outline-offset: 1px;
}

strong
{
	font-weight: 500;
}

.keep-spaces
{
	white-space: pre-wrap;
}

/* .tab-content
{
	height: 100%;
} */

.tab-pane
{
	height: 100%;
}

.small-cell
{
	padding: 0.25rem !important;
}

body
{
  overflow-x: hidden;
  margin: 0;
  background-color: white !important;
}

.layout
{
	min-height: 100vh;
}

div .border
{
	background-color: #FFFFFF !important;
	border-radius: 16px;
	/* box-shadow: 0 0 10px rgba(0, 0, 0, 0.25); */
}

.row.border
{
	background-color: #FFFFFF !important;
}

/* TODO Удалить костыль с z-index, когда все v-select в mymodal будут с appendBody и все модалки будут mymodal */
.vs__dropdown-menu
{
	z-index: 1000000000 !important;
},

.nav-link.dropdown-item
{
	padding: 0.25rem 1rem !important;
}

.nav-tabs .nav-link.active
{
	border-right: rgba(255,255,255,0);
	border-left: rgba(255,255,255,0);
	border-top: rgba(255,255,255,0);
	/* border-bottom: 2px solid #0000ff; */
	color: unset;
}

.nav-tabs .nav-link.disabled
{
	color: var(--bft-neutral-300);
}

.nav-tabs .nav-link
{
	border: unset;
	color: var(--bft-neutral-900);
}

.nav-tabs .nav-link:hover:not(.active)
{
	border: unset;
}

.nav-tabs
{
	border-bottom: 1px solid #dee2e6;
}

.resizable
{
    position: relative;
	display: table;
	width: 100%;
}

.resizing
{
	user-select: none;
}

.resizer
{
    position: absolute;
}

.resizer_right
{
    cursor: col-resize;
    height: 100%;
    right: 0;
    top: 0;
    width: 5px;
}

.resizer_bottom
{
    bottom: 0;
    cursor: row-resize;
    height: 5px;
    left: 0;
    width: 100%;
}

.router-div
{
	cursor: pointer;
}


.my_content
{
	height: calc(100% - 5rem - 1px);
	flex: 1;
	overflow-x: hidden;
	overflow-y: auto;
}

.sidebar_groups
{
	height: 67%;
	border-bottom: 4px solid var(--bft-blue-50);
	display: flex;
	flex-direction: column;
}

.sidebar_groups .nav-tabs .nav-link.active
{
	background-color: transparent;
}

.sidebar_groups > .tree
{
	/* height: calc(100% - .4px - 1rem - 1.5rem); */
	flex: 1;
}

.sidebar_without_groups
{
	height: 33%;
}

.main-container
{
	height: 100%;
	display: flex;
	flex-direction: column;
}

.main-container_content
{
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
}

/* spiner */

.spinner-border
{
	width: 3rem;
	height: 3rem;
	mask: conic-gradient(from 180deg at 50% 50%, var(--bft-blue-500) 0deg, rgba(0, 140, 255, 0) 240.81deg, rgba(0, 140, 255, 0) 360deg),
		linear-gradient(#000 0 0) content-box
	;
	mask-composite: subtract;
	border: .5rem solid var(--bft-blue-500);
	animation-direction: reverse;
}

/* Scrollbar */

@-moz-document url-prefix() {
	* {
		scrollbar-color: transparent transparent;
		scrollbar-width: thin;
	}

	*:hover {
		scrollbar-color: var(--bft-neutral-300) transparent;
	}
}

*::-webkit-scrollbar
{
	background-color: transparent !important;
	width: 12px !important;
	height: 12px !important;
}

*::-webkit-scrollbar-thumb
{
	background-color: transparent !important;
	border-radius: 6px !important;
	border: 4px solid white !important;
}

*:hover::-webkit-scrollbar-thumb
{
	background-color: var(--bft-neutral-300) !important;
}

</style>

<style src="./styles/table.css"></style>
<style src="./styles/main_tree.css"></style>
<style src="./styles/text.css"></style>
<style src="./styles/tooltip.css"></style>
<style src="./styles/input.css"></style>
<style src="./styles/bft_colors.css"></style>
<style src="./styles/button.css"></style>
<style src="./styles/modal.css"></style>
<style src="./styles/notification.css"></style>
